export default {
    OUTRA: 13,
}